// extracted by extract-css-chunks-webpack-plugin
module.exports = {"clearfix":"clearfix--4RtL1ND","box_06_title":"box_06_title-1zmjn2Xu","more":"more-3uYLPbDM","title_word":"title_word-2RcrUMyv"};